import React from 'react';
import { FooterBar } from '../cash-register/footer-bar/footer-bar';
import { FooterBarItem } from '../cash-register/footer-bar/footer-bar-item';
import { useT } from '../../utils/helper';
import { AppStackScreenProps } from '../../routes';
import { useNavigation, useRoute } from '@react-navigation/native';
import { tw } from '../../utils/tailwind';
import { ViewStyle } from 'react-native';
import { useTenant } from '../../contexs/tenant-context';

interface OrdersNavigationProps {
  style?: ViewStyle;
}

export const OrdersNavigation = (props: OrdersNavigationProps) => {
  const t = useT('navigation');
  const route = useRoute();
  const { tenant } = useTenant();
  const navigation =
    useNavigation<AppStackScreenProps<'VendorDashboard'>['navigation']>();

  // If cash register is not enabled, don't show the navigation
  if (!tenant.plan.cash_register_enabled) {
    return null;
  }

  const renderNavItem = (
    text: string,
    routeName: 'VendorDashboard' | 'DeliveredCarts',
    style: ViewStyle,
  ) => {
    return (
      <FooterBarItem
        key={routeName}
        active={route.name === routeName}
        onPress={() => navigation.navigate(routeName)}
        text={text}
        buttonStyles={[tw`md:px-3 md:py-4 py-3`, style]}
        textStyles={tw`md:text-lg text-base`}
      />
    );
  };

  return (
    <FooterBar style={props.style}>
      {renderNavItem(t('currentOrders'), 'VendorDashboard', tw`rounded-l-lg`)}
      {renderNavItem(t('completedOrders'), 'DeliveredCarts', tw`rounded-r-lg`)}
    </FooterBar>
  );
};
